import React from "react"

import { useIntl } from "react-intl"
import Card from "react-bootstrap/Card"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Layout1 from "../components/layout_1"
import FormattedMarkdown from "../components/formatted_markdown"
import PoliciesNavigation from "../components/policies_navigation"

const CookiePolicyPage = ({ location }) => {
  const intl = useIntl()
  const pageTitle = intl.formatMessage({ id: "Cookie Policy" })
  return (
    <Layout pageTitle={pageTitle} location={location}>
      <SEO title={pageTitle} />
      <PoliciesNavigation location={location} />
      <Layout1
        center={
          <Card>
            <Card.Body>
              <Card.Text style={{ textAlign: "left" }}>
                <FormattedMarkdown id="Cookie Policy.Cookie Policy" />
              </Card.Text>
            </Card.Body>
          </Card>
        }
      />
    </Layout>
  )
}

export default CookiePolicyPage
